var _style, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "freepik_stories-404-error-with-portals",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-404-error-with-portals:not(.animated) .animable {opacity: 0;}svg#freepik_stories-404-error-with-portals.animated #freepik--Background--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-404-error-with-portals.animated #freepik--Portal--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-404-error-with-portals.animated #freepik--Sparkles--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-404-error-with-portals.animated #freepik--number-2--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,3s Infinite  linear floating;animation-delay: 0s,2.5s;}svg#freepik_stories-404-error-with-portals.animated #freepik--number-1--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft,3s Infinite  linear floating;animation-delay: 0s,1.5s;}svg#freepik_stories-404-error-with-portals.animated #freepik--speech-bubble--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut,6s Infinite  linear heartbeat;animation-delay: 0s,1s;}svg#freepik_stories-404-error-with-portals.animated #freepik--Character--inject-5 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Background--inject-5",
    className: "animable animator-active",
    style: {
      transformOrigin: "250.652px 253.027px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background--inject-5",
    className: "animable",
    style: {
      transformOrigin: "250.652px 253.027px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M488.89,246.17c-5.18-53.7-32.15-107.27-55.41-136.86C334.86-16.09,137-15.85,42.68,141.66,16.09,186.08-.6,284.85,19.15,357.9,44.42,451.4,144,487.81,254.74,487,358.21,486.15,439.57,441.16,470,379,489.09,340.13,494.07,299.87,488.89,246.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.652px 253.027px"
    },
    id: "elv7r1vahx9np",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.68,141.66C16.09,186.08-.6,284.85,19.15,357.9A148.64,148.64,0,0,0,39,402h0l110-63.47,93.7-54.09h0L462.76,157.32h0c-9.16-19-19.54-35.62-29.27-48C334.86-16.09,137-15.85,42.68,141.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.628px 210.521px"
    },
    id: "el17gw5r5nvkk",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Portal--inject-5",
    className: "animable",
    style: {
      transformOrigin: "289.565px 278.351px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--portal--inject-5",
    className: "animable",
    style: {
      transformOrigin: "289.565px 278.351px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "eldkjogq6wm5s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.54,326.27V313.93l-17.82-10.29V291.3L269.9,281V268.67l-17.81-10.29-77,42,20,11.49v12.34l17.82,10.28v12.35l17.82,10.28v12.35l78.06,112.81C386.09,469.23,445.1,429.87,470,379q4.32-8.82,7.69-17.77h0Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.2,
      transformOrigin: "326.39px 370.33px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx668uz35hp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.78,85.7c-52.1,30-94.34,110.4-94.34,179.62,0,41.13,14.92,69.06,38,78.66l9.53-5.5,93.7-54.09h0l9.77-5.64c22.91-36.05,37.72-81,37.72-122C290.12,87.55,247.89,55.73,195.78,85.7Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.15,
      transformOrigin: "195.8px 209.201px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzffyn158ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.78,105.72c-43.78,25.2-79.27,92.76-79.27,150.93s35.49,84.91,79.27,59.73,79.28-92.77,79.28-150.94S239.57,80.53,195.78,105.72Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.15,
      transformOrigin: "195.785px 211.047px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmfr0f9856ho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.78,119.83c-37.78,21.82-68.41,80.34-68.41,130.71s30.63,73.54,68.41,51.73,68.41-80.34,68.41-130.72S233.57,98,195.78,119.83Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.15,
      transformOrigin: "195.78px 211.044px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.44,252.93c0-43.64,26.54-94.34,59.27-113.25,14.43-8.32,27.64-9.09,37.91-3.61l-13.31-7.7c-10.4-6-24-5.5-38.84,3.08-32.75,18.91-59.28,69.61-59.28,113.25,0,23.89,7.95,40.71,20.52,47.95,2.15,1.23,10.14,5.86,13.4,7.74C163,292.88,155.44,276.28,155.44,252.93Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "196.905px 212.375px"
    },
    id: "elh7j006bo3gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld7drtnwaxak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.44,252.93c0-43.64,26.54-94.34,59.27-113.25,14.43-8.32,27.64-9.09,37.91-3.61l-13.31-7.7c-10.4-6-24-5.5-38.84,3.08-32.75,18.91-59.28,69.61-59.28,113.25,0,23.89,7.95,40.71,20.52,47.95,2.15,1.23,10.14,5.86,13.4,7.74C163,292.88,155.44,276.28,155.44,252.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "196.905px 212.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238,148.83c5.17,6.9,7.94,17.88,7.32,32.16-1.49,35-22.78,76.64-47.54,92.93-7.52,4.95-14.51,7-20.53,6.45,7.52,10,20.12,11.43,34.78,1.78,24.77-16.29,46.06-57.9,47.55-92.94C260.6,164.83,251.78,150.06,238,148.83Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "218.455px 218.754px"
    },
    id: "elbyx6s3a06xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1l1fs2obpj6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238,148.83c5.17,6.9,7.94,17.88,7.32,32.16-1.49,35-22.78,76.64-47.54,92.93-7.52,4.95-14.51,7-20.53,6.45,7.52,10,20.12,11.43,34.78,1.78,24.77-16.29,46.06-57.9,47.55-92.94C260.6,164.83,251.78,150.06,238,148.83Z",
    style: {
      opacity: 0.15,
      transformOrigin: "218.455px 218.754px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.54,159.55l14.25,8.23,1.14-1.53L171.68,158C171.29,158.53,170.92,159,170.54,159.55Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "178.235px 162.89px"
    },
    id: "eli6icou0it4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,207.21,149.7,199c-.2.55-.39,1.12-.58,1.68l14.25,8.23C163.57,208.33,163.75,207.76,164,207.21Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "156.56px 203.955px"
    },
    id: "el1juhqf7zaeu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,124.74,243.26,133c.58.1,1.16.2,1.73.32l-14.26-8.23C230.16,124.94,229.58,124.83,229,124.74Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "236.995px 129.03px"
    },
    id: "elen72e7gwq3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.45,231.38c.11-.62.23-1.25.35-1.87l-14.25-8.23c-.13.62-.25,1.24-.36,1.87Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "150.495px 226.33px"
    },
    id: "elbi8f4xx1di7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,143.55l14.25,8.23c.49-.47,1-.94,1.48-1.39L186,142.16C185.53,142.61,185,143.08,184.55,143.55Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "192.415px 146.97px"
    },
    id: "ellb22rl4mbpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.52,272.52c-.13-.55-.25-1.11-.37-1.67l-.11-.25-14.18-8.19c.13.64.26,1.27.41,1.89Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "150.19px 267.465px"
    },
    id: "ela12fhei9h1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.57,125.11c-.6.12-1.22.28-1.83.43L229,133.77c.62-.16,1.24-.3,1.85-.42Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "222.795px 129.44px"
    },
    id: "el09p9jm5simlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,139.2,201.35,131c-.3.17-.59.31-.88.48l-.87.53,14.25,8.23.86-.53Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "207.6px 135.62px"
    },
    id: "elysgm3ick2di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,179l14.25,8.23.84-1.56-14.25-8.23C159,177.94,158.73,178.46,158.46,179Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "166.005px 182.335px"
    },
    id: "elh26y3g1gnjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.57,288.22c-.32-.55-.62-1.1-.93-1.67l-14.24-8.22c.3.57.62,1.12.94,1.67Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "155.985px 283.275px"
    },
    id: "el2mu5ck7coci",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,244.86l14.25,8.24v-.17c0-.61,0-1.24,0-1.86l-14.26-8.23c0,.62,0,1.25,0,1.86Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "148.31px 247.97px"
    },
    id: "elmd2462jbb8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,139.68c-32.73,18.91-59.27,69.61-59.27,113.25s26.54,63.71,59.27,44.81S274,228.14,274,184.49,247.45,120.78,214.71,139.68Zm44.84,49.53c-1.49,35-22.78,76.64-47.55,92.93s-43.62,1.1-42.13-33.93,22.8-76.64,47.55-92.93S261.05,154.18,259.55,189.21Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "214.72px 218.709px"
    },
    id: "elipln114xyra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9a76z7p8pj7"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "214.73px 218.645px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.58,168.45c.48-.53.95-1.07,1.44-1.59l-3.75-16.47c-.5.45-1,.91-1.48,1.38Z",
    id: "el2937aq9b9r5",
    className: "animable",
    style: {
      transformOrigin: "201.405px 159.42px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.84,140.2v17.66c.58-.45,1.16-.89,1.75-1.31V139.19l-.88.49Z",
    id: "elwiagzlp0jc9",
    className: "animable",
    style: {
      transformOrigin: "214.715px 148.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.89,150.84c.64-.25,1.28-.48,1.91-.68l3-16.82c-.61.12-1.23.26-1.85.41Z",
    id: "elijpcw698pa",
    className: "animable",
    style: {
      transformOrigin: "228.345px 142.09px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.57,211.61l.63-1.66L164,207.2c-.2.56-.4,1.12-.59,1.68Z",
    id: "elvnlm39nqtv",
    className: "animable",
    style: {
      transformOrigin: "170.805px 209.405px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,196l.8-1.6-11.56-8.74-.83,1.57Z",
    id: "el4e9d14rdq1r",
    className: "animable",
    style: {
      transformOrigin: "178.905px 190.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.57,163.53,259,175.32c.1.7.19,1.41.27,2.15l12.81-12C271.89,164.83,271.74,164.17,271.57,163.53Z",
    id: "eloiup5j2tkbn",
    className: "animable",
    style: {
      transformOrigin: "265.54px 170.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3,242.5l-14.84,8.56c0,.63,0,1.25,0,1.87v.17l14.66-8.46C170.15,243.93,170.23,243.21,170.3,242.5Z",
    id: "eli3yo158o17p",
    className: "animable",
    style: {
      transformOrigin: "162.88px 247.8px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.7,228c.15-.63.31-1.26.46-1.9l-15.37,3.39c-.12.62-.24,1.25-.35,1.87Z",
    id: "elcoqgihjwcb",
    className: "animable",
    style: {
      transformOrigin: "165.3px 228.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,148.82c.61.05,1.2.12,1.78.22L245,133.27c-.58-.12-1.16-.23-1.75-.33Z",
    id: "el9t9634i59n7",
    className: "animable",
    style: {
      transformOrigin: "241.35px 140.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,161.94c.28.59.55,1.21.81,1.84l10.3-13.87c-.31-.56-.64-1.1-1-1.63Z",
    id: "eldsd6nfqh94n",
    className: "animable",
    style: {
      transformOrigin: "260.695px 156.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.86,152.65c.47.36.93.74,1.38,1.15L257,138.94c-.47-.37-.94-.72-1.43-1.06Z",
    id: "el23p833jealv",
    className: "animable",
    style: {
      transformOrigin: "252.43px 145.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.67,181.44l1.08-1.63-7.83-13.57-1.14,1.54Z",
    id: "ely1r51k9i27",
    className: "animable",
    style: {
      transformOrigin: "189.265px 173.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.15,268.63c-.47.55-1,1.08-1.43,1.6l3.75,16.52c.5-.45,1-.94,1.48-1.41Z",
    id: "elmonclatjssh",
    className: "animable",
    style: {
      transformOrigin: "228.335px 277.69px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.74,240.22c-.26.54-.53,1.07-.8,1.6l11.59,8.76.81-1.59Z",
    id: "el13jwhc6lucmb",
    className: "animable",
    style: {
      transformOrigin: "251.14px 245.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.28,255.2l-1.08,1.64,7.85,13.6c.38-.51.77-1,1.14-1.53Z",
    id: "elal2bljqriqt",
    className: "animable",
    style: {
      transformOrigin: "240.695px 262.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.42,224.23c-.2.56-.39,1.12-.6,1.67l14.2,2.74c.2-.56.39-1.12.58-1.68Z",
    id: "elipuz5pc07uo",
    className: "animable",
    style: {
      transformOrigin: "259.21px 226.435px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11,207.64c-.13.63-.26,1.26-.41,1.88L272,206.17c.11-.63.21-1.25.32-1.87Z",
    id: "ely06f2db0f6",
    className: "animable",
    style: {
      transformOrigin: "264.51px 206.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,182.65,259.44,191c0,.7-.09,1.4-.14,2.11L274,184.66v-.17C274,183.87,274,183.26,274,182.65Z",
    id: "elv69ndsw4lqb",
    className: "animable",
    style: {
      transformOrigin: "266.65px 187.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.59,297.21V279.57c-.58.45-1.17.89-1.75,1.31v17.36l.87-.5C215,297.57,215.3,297.38,215.59,297.21Z",
    id: "el8fkncz80yw6",
    className: "animable",
    style: {
      transformOrigin: "214.715px 288.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,274.44c-.27-.61-.53-1.24-.78-1.9l-10.39,14c.3.57.62,1.13.94,1.67Z",
    id: "elinspgnlf69j",
    className: "animable",
    style: {
      transformOrigin: "168.225px 280.375px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.94,284.29c-.46-.38-.91-.78-1.35-1.21L171.79,298c.46.38.93.74,1.41,1.09Z",
    id: "eltarvhaiq4c",
    className: "animable",
    style: {
      transformOrigin: "176.365px 291.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,286.73c-.64.24-1.27.45-1.9.65l-3,16.77c.62-.12,1.24-.25,1.86-.4Z",
    id: "el74fwj0glu1l",
    className: "animable",
    style: {
      transformOrigin: "200.75px 295.44px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.15,288.56c-.6-.06-1.18-.15-1.76-.26L183.93,304c.58.14,1.16.25,1.74.35Z",
    id: "eleocrf349g3",
    className: "animable",
    style: {
      transformOrigin: "187.54px 296.325px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.27,260.61c-.08-.72-.15-1.46-.21-2.21l-13,12.13c.14.67.28,1.33.43,2Z",
    id: "elulh2cwogyjg",
    className: "animable",
    style: {
      transformOrigin: "163.665px 265.465px"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "230.71 369.48 162.97 330.37 162.97 293.34 177.23 301.57 195.07 311.88 195.07 324.22 212.89 334.5 212.89 346.85 230.71 357.13 230.71 369.48",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.84px 331.41px"
    },
    id: "eltmo8gpn2d1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.25 301.59 252.09 258.38 269.9 268.67 195.07 311.88 177.25 301.59",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "223.575px 285.13px"
    },
    id: "elqtiigm1tlx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.07 311.88 195.07 324.22 269.9 281.01 269.9 268.67 195.07 311.88",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "232.485px 296.445px"
    },
    id: "elnb4kbzq8da9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.07 324.22 269.9 281.01 287.72 291.3 212.89 334.5 195.07 324.22",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "241.395px 307.755px"
    },
    id: "eljuzg13r3toa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.89 334.5 212.89 346.85 287.72 303.64 287.72 291.3 212.89 334.5",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.305px 319.075px"
    },
    id: "ell7msshjnz1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.89 346.85 287.72 303.64 305.54 313.93 230.71 357.13 212.89 346.85",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "259.215px 330.385px"
    },
    id: "el3nph46p3z0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.71 357.13 230.71 369.48 305.54 326.27 305.54 313.93 230.71 357.13",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "268.125px 341.705px"
    },
    id: "elkbhmgm1v8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.14,185c-1.49,35-22.79,76.64-47.55,92.94-9.2,6.05-17.58,7.76-24.42,5.71-7-6.39-11-18.63-10.3-35.42,1.5-35,22.8-76.64,47.55-92.93,9.21-6.06,17.61-7.76,24.44-5.7C248.9,156,252.86,168.2,252.14,185Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "211.007px 216.621px"
    },
    id: "el8av9sx9yva9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg8vwpq0bdre"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.14,185c-1.49,35-22.79,76.64-47.55,92.94-9.2,6.05-17.58,7.76-24.42,5.71-7-6.39-11-18.63-10.3-35.42,1.5-35,22.8-76.64,47.55-92.93,9.21-6.06,17.61-7.76,24.44-5.7C248.9,156,252.86,168.2,252.14,185Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "211.007px 216.621px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el18c6v05umxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.48,260a32.52,32.52,0,0,0-20.16,10.25,37.89,37.89,0,0,0-6.88,10.39,23.77,23.77,0,0,0,2.73,3,20.26,20.26,0,0,0,4.52.78c.4-1,.7-2.05,1.05-3.06a25.4,25.4,0,0,1,22.74-16.61c3.43-.09,6.83.53,10.24.8,1.35-1.49,2.67-3,4-4.64C216.68,260.6,210.45,259.4,204.48,260ZM203,208.79c7,.91,14.64,1.3,20.76-2.28,6.93-4.06,10.22-12.11,13.56-19.4,3.11-6.77,7.36-13.92,14.15-16.54-1.41-9.47-4.79-16.6-9.62-21a21.52,21.52,0,0,0-10.13-.43,34.2,34.2,0,0,0-7.22,13.44c-1.6,5.6-2.16,11.55-4.73,16.76a24,24,0,0,1-12.49,11.53c-4.28,1.7-8.93,2.11-13.48,2.81a69.34,69.34,0,0,0-9.39,2.06,145.35,145.35,0,0,0-6.34,14.51,24.93,24.93,0,0,1,3.82-1.57C188.68,206.59,196,207.89,203,208.79Zm7.16-35c2.24-3.87,3-8.38,4.23-12.69.44-1.61,1-3.18,1.52-4.75q-2.4,1.69-4.76,3.68c-2.26,5.49-4.46,11-8.63,15.14a21.33,21.33,0,0,1-7.45,4.74,8.47,8.47,0,0,1-1.62.37q-1.53,2.25-3,4.6a38.12,38.12,0,0,0,6.68-1.14A23.2,23.2,0,0,0,210.17,173.76Zm42,6.07a19.64,19.64,0,0,0-5.24,3.95c-3.72,4.08-5.72,9.37-8,14.41-3.18,7.18-7.33,14.49-14.24,18.21-4.6,2.47-10,3.09-15.17,3.23-9.85.27-19.85-1-29.48,1.11a34.13,34.13,0,0,0-6.06,1.93q-1,3.59-1.75,7.15a32.81,32.81,0,0,1,7.07-2.75c14.23-3.6,30,4.3,43.63-1,10-3.91,16.09-13.84,21-23.38,2-3.89,4.15-8,7.6-10.58q.4-3.57.56-7.08C252.21,183.21,252.23,181.5,252.2,179.83Zm-35.5,58.29c-7.7.28-15.39-.44-23.09-.55a37.82,37.82,0,0,0-11.72,1.2,33.64,33.64,0,0,0-9.32,4.89c-.87.62-1.71,1.26-2.54,1.91-.06.89-.12,1.77-.16,2.64-.43,10.15.86,18.62,3.49,25.16a27.37,27.37,0,0,0,4.5-5c5.29-7.15,10.39-15.06,18.41-18.89,8.61-4.11,18.76-2.64,28.12-4.52A39,39,0,0,0,236,240.58q2.22-4.16,4.19-8.48c-.4.24-.81.47-1.22.7C232.2,236.51,224.39,237.84,216.7,238.12Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.1,
      transformOrigin: "210.98px 216.575px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-5",
    className: "animable",
    style: {
      transformOrigin: "206.66px 215.81px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sparkles--inject-5",
    className: "animable",
    style: {
      transformOrigin: "206.66px 215.81px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.61,123.37c0,3.4-.64,6.42-4.8,7.15,4.26.18,4.56,3,4.8,6.94.14-3.91.51-6.76,4.37-6.94C270,129.86,269.61,126.77,269.61,123.37Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "269.395px 130.415px"
    },
    id: "elm0klpfn19g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,304.38c0,3.4-.64,6.42-4.8,7.15,4.26.18,4.56,3,4.8,6.94.14-3.92.51-6.76,4.37-6.94C172.92,310.86,172.55,307.78,172.55,304.38Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "172.335px 311.425px"
    },
    id: "el6m6xbh86bj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.28,199.62c0,1.49-.28,2.8-2.1,3.12,1.86.08,2,1.33,2.1,3,.06-1.71.22-3,1.91-3C141.44,202.45,141.28,201.11,141.28,199.62Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "141.185px 202.68px"
    },
    id: "elybt79xzsrkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.1,205.47c0,3.39-.65,6.41-4.8,7.14,4.26.18,4.56,3,4.8,6.95.13-3.92.5-6.76,4.37-6.95C133.47,212,133.1,208.86,133.1,205.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "132.885px 212.515px"
    },
    id: "eljz69i4m3gsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.2,188.43c0,1.75-.33,3.29-2.46,3.67,2.18.09,2.34,1.55,2.46,3.56.07-2,.26-3.47,2.25-3.56C129.39,191.76,129.2,190.18,129.2,188.43Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "129.095px 192.045px"
    },
    id: "elhq5ztuuout5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,113.15c0,2-.05,3.9-2.92,4.35,3,0,2.8,1.87,2.95,4.27.08-2.4.29-4.12,2.66-4.23C258.3,117.13,258.37,116,258.06,113.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "257.945px 117.46px"
    },
    id: "el2ry52pkjyly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,205.7c-.21,3.75-.51,5.37-3.9,5.82,3.45.19,3.74,2.48,3.94,5.67.11-3.19.39-5.51,3.54-5.67C283.34,211,283.26,209.5,283,205.7Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "282.84px 211.445px"
    },
    id: "elh3pe0cgt2pi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,304.41c-.12,2.19-.29,3.13-2.27,3.4,2,.11,2.18,1.43,2.3,3.29.06-1.86.22-3.21,2.06-3.29C159,307.49,158.92,306.63,158.77,304.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "158.68px 307.755px"
    },
    id: "elvdzfgyxng4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.92,119.89c0,1.21,0,2.37-1.77,2.64,1.84,0,1.7,1.13,1.79,2.58.05-1.45.17-2.49,1.6-2.56C276.06,122.3,276.1,121.62,275.92,119.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.845px 122.5px"
    },
    id: "el5wsfr18iosk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.69,216.6c0,1.2,0,2.36-1.77,2.63,1.83,0,1.69,1.14,1.78,2.59.05-1.45.18-2.5,1.61-2.56C279.83,219,279.87,218.32,279.69,216.6Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "279.615px 219.21px"
    },
    id: "eldgub1gpu3gm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,299.64c0,1.2,0,2.36-1.77,2.63,1.84,0,1.7,1.13,1.79,2.58.05-1.45.18-2.49,1.61-2.56C168.17,302.05,168.21,301.36,168,299.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "167.93px 302.245px"
    },
    id: "el4yrad2qlq74",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-2--inject-5",
    className: "animable",
    style: {
      transformOrigin: "380.6px 196.295px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M367.25,289.58l31.49-18.18,47.54,27.44,22.81-13.17-47.53-27.44L437,249.31l-25-14.45-15.44,8.92L369,227.89l-22.82,13.18L373.71,257,315,290.84l18.37,10.6,148.18,39.78,2.88-1.66q2.12-8.52,3.51-17.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.47px 284.555px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-5",
    className: "animable",
    style: {
      transformOrigin: "328.86px 147.3px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.21,150.09l-1.18.68V112.35l-14.26-8.23L337.13,114.3l14.55-54.7-14.25-8.23L312.9,65.53,273.26,213.75V235l14.25,8.23L332,217.53v15.31l14.26,8.23L369,227.89V196.13l15.43-8.91v-28.9ZM332,172.18l-12.07,7L332,133.76Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "328.845px 147.3px"
    },
    id: "elh8y9o1hvyai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvnvfxgw201"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.21,150.09l-1.18.68V112.35l-14.26-8.23L337.13,114.3l14.55-54.7-14.25-8.23L312.9,65.53,273.26,213.75V235l14.25,8.23L332,217.53v15.31l14.26,8.23L369,227.89V196.13l15.43-8.91v-28.9ZM332,172.18l-12.07,7L332,133.76Z",
    style: {
      opacity: 0.3,
      transformOrigin: "328.845px 147.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "369.02 167.23 369.02 112.35 346.21 125.52 346.21 180.41 314.71 198.59 351.68 59.6 327.15 73.76 287.51 221.98 287.51 243.19 346.21 209.31 346.21 241.07 369.02 227.89 369.02 196.13 384.46 187.22 384.46 158.32 369.02 167.23",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "335.985px 151.395px"
    },
    id: "el5rr880s9u0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln5y6oxpcvk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "369.02 167.23 369.02 112.35 346.21 125.52 346.21 180.41 314.71 198.59 351.68 59.6 327.15 73.76 287.51 221.98 287.51 243.19 346.21 209.31 346.21 241.07 369.02 227.89 369.02 196.13 384.46 187.22 384.46 158.32 369.02 167.23",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "335.985px 151.395px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "351.68 59.6 337.43 51.37 312.9 65.53 327.15 73.76 351.68 59.6",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "332.29px 62.565px"
    },
    id: "elgh29agx9lzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnb5335g7hfd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.68 59.6 337.43 51.37 312.9 65.53 327.15 73.76 351.68 59.6",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "332.29px 62.565px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "354.77 104.12 369.02 112.35 346.21 125.52 335.75 119.48 337.13 114.3 354.77 104.12",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "352.385px 114.82px"
    },
    id: "el7i2mr3ww2bq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt7fdrx0mxnq"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.77 104.12 369.02 112.35 346.21 125.52 335.75 119.48 337.13 114.3 354.77 104.12",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "352.385px 114.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "346.21 180.41 331.95 172.18 319.88 179.15 314.71 198.59 346.21 180.41",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "330.46px 185.385px"
    },
    id: "eljh3gp7gybhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellbjwpuzrmss"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.21 180.41 331.95 172.18 319.88 179.15 314.71 198.59 346.21 180.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "330.46px 185.385px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "384.46 158.32 370.21 150.09 369.02 150.77 369.02 167.23 384.46 158.32",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "376.74px 158.66px"
    },
    id: "elift58eo9pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxiev8sbqefo"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "369.02 167.23 384.46 158.32 370.21 150.09 369.02 150.77 369.02 167.23",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "376.74px 158.66px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "287.51 221.98 273.26 213.75 312.9 65.53 327.15 73.76 287.51 221.98",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "300.205px 143.755px"
    },
    id: "elljtd80uuwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcxrd1r291b7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "287.51 221.98 273.26 213.75 312.9 65.53 327.15 73.76 287.51 221.98",
    style: {
      opacity: 0.15,
      transformOrigin: "300.205px 143.755px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--number-1--inject-5",
    className: "animable",
    style: {
      transformOrigin: "158.135px 329.98px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-5",
    points: "205.45 383 180.42 368.55 164.99 377.46 137.48 361.58 114.66 374.75 142.17 390.63 83.47 424.52 101.84 435.13 250.03 474.91 274.56 460.75 135.7 423.27 167.2 405.08 214.73 432.53 237.55 419.35 190.01 391.91 205.45 383",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.015px 418.245px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--4--inject-5",
    className: "animable",
    style: {
      transformOrigin: "97.33px 280.965px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.66,283.77l-1.18.69V246l-14.26-8.23L105.58,248l14.55-54.7-14.25-8.23L81.35,199.21,41.71,347.44v21.21L56,376.88l44.45-25.66v15.3l14.25,8.23,22.82-13.17V329.81l15.43-8.91V292Zm-38.25,22.09-12.07,7,12.07-45.38Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "97.33px 280.975px"
    },
    id: "elkul4f186x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1p5qr2m1u34i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.66,283.77l-1.18.69V246l-14.26-8.23L105.58,248l14.55-54.7-14.25-8.23L81.35,199.21,41.71,347.44v21.21L56,376.88l44.45-25.66v15.3l14.25,8.23,22.82-13.17V329.81l15.43-8.91V292Zm-38.25,22.09-12.07,7,12.07-45.38Z",
    style: {
      opacity: 0.3,
      transformOrigin: "97.33px 280.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "137.48 300.92 137.48 246.03 114.66 259.2 114.66 314.09 83.16 332.27 120.14 193.28 95.61 207.44 55.96 355.66 55.96 376.88 114.66 342.99 114.66 374.75 137.48 361.58 137.48 329.81 152.91 320.9 152.91 292 137.48 300.92",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "104.435px 285.08px"
    },
    id: "elf64ao2g2sd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8pzg8ayv9ol"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.48 300.92 137.48 246.03 114.66 259.2 114.66 314.09 83.16 332.27 120.14 193.28 95.61 207.44 55.96 355.66 55.96 376.88 114.66 342.99 114.66 374.75 137.48 361.58 137.48 329.81 152.91 320.9 152.91 292 137.48 300.92",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "104.435px 285.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "120.14 193.28 105.88 185.05 81.35 199.21 95.61 207.44 120.14 193.28",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "100.745px 196.245px"
    },
    id: "elm1ww8rkmrkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfbn6pqffhpc"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "120.14 193.28 105.88 185.05 81.35 199.21 95.61 207.44 120.14 193.28",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "100.745px 196.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "123.22 237.8 137.48 246.03 114.66 259.2 104.2 253.17 105.58 247.99 123.22 237.8",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "120.84px 248.5px"
    },
    id: "elc2r27v36adb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt94jd6s0adk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "123.22 237.8 137.48 246.03 114.66 259.2 104.2 253.17 105.58 247.99 123.22 237.8",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "120.84px 248.5px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "114.66 314.09 100.41 305.86 88.34 312.83 83.16 332.27 114.66 314.09",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "98.91px 319.065px"
    },
    id: "elxnkvhfb394e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elymdq10ggwrs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "114.66 314.09 100.41 305.86 88.34 312.83 83.16 332.27 114.66 314.09",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "98.91px 319.065px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "152.91 292 138.66 283.77 137.48 284.46 137.48 300.92 152.91 292",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "145.195px 292.345px"
    },
    id: "elh3lqbk4eo8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc2z1zf9c4cl"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "137.48 300.92 152.91 292 138.66 283.77 137.48 284.46 137.48 300.92",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "145.195px 292.345px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "55.96 355.66 41.71 347.44 81.35 199.21 95.61 207.44 55.96 355.66",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "68.66px 277.435px"
    },
    id: "elxq3rn6qxx6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrcxfzqxawa"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.96 355.66 41.71 347.44 81.35 199.21 95.61 207.44 55.96 355.66",
    style: {
      opacity: 0.15,
      transformOrigin: "68.66px 277.435px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5",
    className: "animable",
    style: {
      transformOrigin: "146.725px 104.937px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5",
    className: "animable",
    style: {
      transformOrigin: "146.725px 104.937px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5",
    className: "animable",
    style: {
      transformOrigin: "146.725px 104.937px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.37,113.46c.58-2.74-10.59,3.71-11.17,6.45l3.6,9.69a1.49,1.49,0,0,0,.6.7c.79.49,3.7,2.13,3.95,2.28a1.55,1.55,0,0,0,2.3-.85l4.67-16C157.61,114.39,153.37,113.46,153.37,113.46Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "149.767px 122.806px"
    },
    id: "elspr9g598wz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvhugqlfel9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.37,113.46c.58-2.74-10.59,3.71-11.17,6.45l3.6,9.69a1.49,1.49,0,0,0,.6.7c.79.49,3.7,2.13,3.95,2.28a1.55,1.55,0,0,0,2.3-.85l4.67-16C157.61,114.39,153.37,113.46,153.37,113.46Z",
    style: {
      opacity: 0.25,
      transformOrigin: "149.767px 122.806px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.35,60l-93.2,53.76a3.33,3.33,0,0,0-1.49,2.6v30.41a3.28,3.28,0,0,0,1.5,2.59l.93.54a3.34,3.34,0,0,0,3,0L195.29,96a3.29,3.29,0,0,0,1.5-2.59V63.08a3.28,3.28,0,0,0-1.5-2.59l-.94-.54A3.34,3.34,0,0,0,191.35,60Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "146.725px 104.937px"
    },
    id: "elvyfpew1xzrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqkenph5365d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.35,60l-93.2,53.76a3.33,3.33,0,0,0-1.49,2.6v30.41a3.28,3.28,0,0,0,1.5,2.59l.93.54a3.34,3.34,0,0,0,3,0L195.29,96a3.29,3.29,0,0,0,1.5-2.59V63.08a3.28,3.28,0,0,0-1.5-2.59l-.94-.54A3.34,3.34,0,0,0,191.35,60Z",
    style: {
      opacity: 0.25,
      transformOrigin: "146.725px 104.937px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.79,63.08v.59a1.38,1.38,0,0,0-2.07-1.2l-92.06,53.18a4.05,4.05,0,0,0-1.51,1.51s0,0,0,0l-4-2.34a3,3,0,0,1,1.08-1.14L191.35,60a3.34,3.34,0,0,1,3,0l.94.54A3.28,3.28,0,0,1,196.79,63.08Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "146.97px 88.4021px"
    },
    id: "elvqerubvqlwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk4phov8h5kf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.79,63.08v.59a1.38,1.38,0,0,0-2.07-1.2l-92.06,53.18a4.05,4.05,0,0,0-1.51,1.51s0,0,0,0l-4-2.34a3,3,0,0,1,1.08-1.14L191.35,60a3.34,3.34,0,0,1,3,0l.94.54A3.28,3.28,0,0,1,196.79,63.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "146.97px 88.4021px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.41,62.82a.79.79,0,0,0-.42.12l-92.06,53.18a3.59,3.59,0,0,0-1.79,3.11v29.08c0,.29,0,.94.6.94a1.36,1.36,0,0,0,.66-.21l44.72-25.83,3,8.28a1.56,1.56,0,0,0,2.91-.14l4-13.88,37.4-21.59c1.25-.71,1.8-1.44,1.8-2.35V63.67A.85.85,0,0,0,195.41,62.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.685px 106.035px"
    },
    id: "elr7prexnjwbe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.74,149.79c-.69,0-1.14-.58-1.14-1.48V119.23a4.13,4.13,0,0,1,2.06-3.57l92.06-53.18a1.33,1.33,0,0,1,.69-.19,1.39,1.39,0,0,1,1.38,1.38V93.53a3.42,3.42,0,0,1-2.07,2.82l-37.21,21.48-4,13.67a2.07,2.07,0,0,1-1.89,1.46,2.09,2.09,0,0,1-2-1.25L146.83,124l-44.16,25.51A1.87,1.87,0,0,1,101.74,149.79Zm93.67-86.43a.28.28,0,0,0-.15,0L103.2,116.58a3.08,3.08,0,0,0-1.53,2.65v29.08a.88.88,0,0,0,.08.42,1.12,1.12,0,0,0,.38-.15l45.27-26.15,3.2,8.88a1,1,0,0,0,1.9-.13l4.1-14.06.18-.11,37.4-21.59c1.35-.78,1.54-1.39,1.54-1.89V63.67A.32.32,0,0,0,195.41,63.36Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "148.695px 106.04px"
    },
    id: "elmee0opg7yx",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvxtsomoj5y9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.74,138c-.59,0-1.29-.41-1.29-1.58V121.92a2.35,2.35,0,0,1,1.16-2.15l.34-.2a1.74,1.74,0,0,1,.84-.24,1.39,1.39,0,0,1,1.31,1l1.7,4.25v-5.73a2.36,2.36,0,0,1,1.16-2.15l.19-.11a1.64,1.64,0,0,1,.82-.24,1.24,1.24,0,0,1,1.22,1,5.6,5.6,0,0,1,.31-.79l.55-1a3.16,3.16,0,0,1,1.2-1.32l3.31-1.91a1.84,1.84,0,0,1,.93-.27,1.54,1.54,0,0,1,1,.36h0a2.35,2.35,0,0,1,1.15-1.88l5.38-3.1a1.59,1.59,0,0,1,.82-.25c.6,0,1.29.42,1.29,1.61V109a2.31,2.31,0,0,1-1.16,2.1l-1.22.71c-.08,0-.21.12-.21.5v12.42a2.36,2.36,0,0,1-1.15,2.15l-.19.11a1.7,1.7,0,0,1-.82.24c-.63,0-1.29-.42-1.29-1.6V113.94l-.5.29a1.62,1.62,0,0,1-.83.25h-.06v11.68a3.92,3.92,0,0,1-.44,1.76l-.55,1.06a3.13,3.13,0,0,1-1.2,1.31l-3.29,1.9a1.85,1.85,0,0,1-1,.28,1.5,1.5,0,0,1-.93-.32l-.57-.42a1.69,1.69,0,0,1-.51-.65v1.37a2.32,2.32,0,0,1-1.16,2.12l-.19.11a1.63,1.63,0,0,1-.84.25,1.39,1.39,0,0,1-1.3-1l-1.86-4.6v6.15a2.34,2.34,0,0,1-1.16,2.13l-.19.11A1.64,1.64,0,0,1,109.74,138Zm11-20.39c-.07,0-.2.12-.2.48v9.66l1.54-.88c.07,0,.2-.12.2-.48v-9.66Zm15.55,5.08c-.59,0-1.29-.41-1.29-1.58V106.63a2.36,2.36,0,0,1,1.16-2.13l5.37-3.09a1.56,1.56,0,0,1,.82-.25,1.22,1.22,0,0,1,1.15.79,4.25,4.25,0,0,1,.21-.49l.55-1a3.1,3.1,0,0,1,1.2-1.32l3.31-1.91a1.81,1.81,0,0,1,.93-.27,1.53,1.53,0,0,1,1,.35l.51.39a1.73,1.73,0,0,1,.52.66V96.94a2.34,2.34,0,0,1,1.16-2.13l.19-.11a1.64,1.64,0,0,1,.82-.24c.59,0,1.29.41,1.29,1.58v11.73l1.53-.89c.08,0,.21-.12.21-.5V93.94A2.34,2.34,0,0,1,158,91.81l.19-.11a1.64,1.64,0,0,1,.82-.24,1.2,1.2,0,0,1,1.08.65v0a2.35,2.35,0,0,1,1.16-2.15l.34-.19a1.59,1.59,0,0,1,.83-.25,1.39,1.39,0,0,1,1.32,1l1.7,4.25V89a2.35,2.35,0,0,1,1.16-2.14l.18-.11a1.61,1.61,0,0,1,.82-.25,1.21,1.21,0,0,1,1.09.67v0A2.34,2.34,0,0,1,169.89,85l4.34-2.5a1.89,1.89,0,0,1,.94-.28,1.56,1.56,0,0,1,1,.36l.51.39a2,2,0,0,1,.72,1.67V96.32a4,4,0,0,1-.44,1.77l-.55,1a3.19,3.19,0,0,1-1.21,1.32L170.84,103a1.7,1.7,0,0,1-.82.24,1.2,1.2,0,0,1-1.09-.65v0a2.35,2.35,0,0,1-1.15,2.13l-.19.1a1.63,1.63,0,0,1-.85.25,1.39,1.39,0,0,1-1.29-.94l-1.87-4.61v6.16a2.34,2.34,0,0,1-1.15,2.12l-.19.11a1.62,1.62,0,0,1-.83.25,1.24,1.24,0,0,1-1.22-1,4.08,4.08,0,0,1-.3.77l-.55,1a3.1,3.1,0,0,1-1.2,1.34l-3.29,1.9a1.9,1.9,0,0,1-.94.27,1.55,1.55,0,0,1-1-.35l-.53-.4a1.83,1.83,0,0,1-.52-.66,3.91,3.91,0,0,1-.44,1.75l-.55,1a3.16,3.16,0,0,1-1.2,1.32l-3.29,1.9a2,2,0,0,1-1,.28,1.55,1.55,0,0,1-.94-.32l-.56-.43a2,2,0,0,1-.72-1.67v-2.82a2.22,2.22,0,0,1-.78.74l-3.82,2.21c-.08.05-.2.12-.2.48v4.67a2.34,2.34,0,0,1-1.16,2.13l-.19.11A1.64,1.64,0,0,1,136.26,122.7Zm10.63-20.19c-.08,0-.2.12-.2.48v9.66l1.53-.89c.08,0,.21-.12.21-.48v-9.66Zm-3.66,1.86a2.16,2.16,0,0,1-.78.75l-3.82,2.2c-.08.05-.2.12-.2.48v3.12l3.07-1.77a1.56,1.56,0,0,1,.82-.25,1.19,1.19,0,0,1,.91.41Zm29.16-16.54c-.09,0-.2.12-.2.48v9.61l1.53-.88c.08,0,.21-.12.21-.48V87Zm14.29,7.78a1.41,1.41,0,0,1-1.34-1l-.94-2.45a4.7,4.7,0,0,1-.28-1.15l-.58-4.56c0-.37,0-.58,0-.67s0-.34,0-.66l.58-5.27a9.66,9.66,0,0,1,.25-1.35l.95-3.56a2.73,2.73,0,0,1,1.23-1.69l.34-.19a1.62,1.62,0,0,1,.83-.25h.21l.17,0a1.24,1.24,0,0,1,.81,1.26,2.67,2.67,0,0,1-.1.73l-1,3.38a6.14,6.14,0,0,0-.21,1.07l-.51,5c0,.23,0,.4,0,.49s0,.25,0,.47l.51,4.37a2.32,2.32,0,0,0,.17.69l1,2.26a2.1,2.1,0,0,1,.14.76,2.15,2.15,0,0,1-.27,1,2,2,0,0,1-.8.81l-.34.2a1.61,1.61,0,0,1-.82.24Zm-5.33-2.42c-.59,0-1.27-.4-1.27-1.54v-1a2.36,2.36,0,0,1,1.15-2.17l.36-.21a1.67,1.67,0,0,1,.82-.24c.62,0,1.29.42,1.29,1.62v1a2.3,2.3,0,0,1-1.16,2.08l-.36.2A1.62,1.62,0,0,1,181.35,93.19Zm0-8.33c-.59,0-1.27-.41-1.27-1.55v-1a2.37,2.37,0,0,1,1.15-2.17l.36-.21a1.64,1.64,0,0,1,.82-.24c.62,0,1.29.43,1.29,1.63v1a2.29,2.29,0,0,1-1.16,2.08l-.36.21A1.62,1.62,0,0,1,181.35,84.86Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.3,
      transformOrigin: "148.695px 105.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el34qbnyc1x88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.74,137.54c-.19,0-.81-.08-.81-1.11V121.92a1.86,1.86,0,0,1,.92-1.74l.34-.2a1.21,1.21,0,0,1,.6-.18.94.94,0,0,1,.87.68l2.61,6.52a1,1,0,0,0,0-.18v-8a1.86,1.86,0,0,1,.92-1.74l.19-.11a1.18,1.18,0,0,1,.58-.18c.19,0,.81.09.81,1.13v14.52a1.85,1.85,0,0,1-.92,1.71l-.19.11a1.21,1.21,0,0,1-.6.18.91.91,0,0,1-.86-.65L111.44,127c0,.06,0,.13,0,.19v8.38a1.86,1.86,0,0,1-.92,1.72l-.18.11A1.24,1.24,0,0,1,109.74,137.54Zm9.53-5.55a1,1,0,0,1-.65-.22l-.56-.42a1.54,1.54,0,0,1-.53-1.3V118.34a3.39,3.39,0,0,1,.39-1.55l.55-1.05a2.76,2.76,0,0,1,1-1.13l3.3-1.9a1.41,1.41,0,0,1,.7-.21,1,1,0,0,1,.68.25l.53.4a1.52,1.52,0,0,1,.53,1.29v11.72a3.45,3.45,0,0,1-.39,1.55l-.55,1a2.67,2.67,0,0,1-1,1.12l-3.29,1.9a1.41,1.41,0,0,1-.71.21Zm1.21-14.78a.91.91,0,0,0-.45.89s0,10.46,0,10.48l2.24-1.29a.91.91,0,0,0,.45-.89s0-10.46,0-10.49Zm7.9,9.57c-.25,0-.82-.11-.82-1.13V113.12l-1.21.7a1.21,1.21,0,0,1-.59.18c-.19,0-.8-.08-.8-1.09v-.25a1.86,1.86,0,0,1,.92-1.73l5.38-3.11a1.18,1.18,0,0,1,.58-.18c.19,0,.81.08.81,1.13V109a1.83,1.83,0,0,1-.91,1.69l-1.23.71a.92.92,0,0,0-.44.91v12.42a1.86,1.86,0,0,1-.92,1.74l-.19.11a1.18,1.18,0,0,1-.58.18Zm7.88-4.55c-.19,0-.81-.08-.81-1.11V106.63a1.86,1.86,0,0,1,.92-1.72l5.36-3.09a1.14,1.14,0,0,1,.59-.18c.19,0,.81.08.81,1.1V103a1.85,1.85,0,0,1-.92,1.72l-3.81,2.2a.89.89,0,0,0-.45.89v3.94l3.78-2.18a1.24,1.24,0,0,1,.59-.18c.19,0,.81.08.81,1.11v.25a1.83,1.83,0,0,1-.92,1.71l-3.81,2.2a.9.9,0,0,0-.45.9v4.67a1.85,1.85,0,0,1-.92,1.72l-.18.1A1.16,1.16,0,0,1,136.26,122.23Zm9.19-5.35a1.08,1.08,0,0,1-.65-.22l-.56-.42a1.54,1.54,0,0,1-.53-1.3V103.22a3.38,3.38,0,0,1,.39-1.54l.55-1.05a2.7,2.7,0,0,1,1-1.13l3.3-1.91a1.41,1.41,0,0,1,.7-.21,1.08,1.08,0,0,1,.68.25l.53.4a1.54,1.54,0,0,1,.53,1.3v11.72a3.38,3.38,0,0,1-.39,1.54l-.55,1a2.76,2.76,0,0,1-1,1.13l-3.29,1.9a1.44,1.44,0,0,1-.71.21Zm1.2-14.78a.9.9,0,0,0-.44.89v10.48l2.25-1.3a.91.91,0,0,0,.45-.89s0-10.46,0-10.48Zm7.26,9.9a1.08,1.08,0,0,1-.68-.25l-.54-.41a1.55,1.55,0,0,1-.53-1.3V96.94a1.85,1.85,0,0,1,.92-1.72l.19-.11a1.18,1.18,0,0,1,.58-.18c.19,0,.81.08.81,1.11v12.55l2.25-1.3a.92.92,0,0,0,.44-.91V93.94a1.86,1.86,0,0,1,.92-1.72l.19-.11a1.21,1.21,0,0,1,.59-.18c.19,0,.81.08.81,1.11v13.11a3.4,3.4,0,0,1-.4,1.54l-.54,1a2.7,2.7,0,0,1-1,1.15l-3.29,1.9a1.38,1.38,0,0,1-.7.21Zm7.5-4.3c-.19,0-.8-.08-.8-1.11V92.08a1.86,1.86,0,0,1,.92-1.73l.34-.2a1.18,1.18,0,0,1,.59-.18.9.9,0,0,1,.87.67L166,97.17c0-.06,0-.12,0-.18V89a1.86,1.86,0,0,1,.92-1.73l.18-.11a1.18,1.18,0,0,1,.58-.18c.19,0,.82.08.82,1.13v14.51a1.83,1.83,0,0,1-.92,1.71l-.19.11a1.14,1.14,0,0,1-.61.19h0a.91.91,0,0,1-.85-.65l-2.77-6.85a1.27,1.27,0,0,0,0,.2v8.38a1.83,1.83,0,0,1-.92,1.71l-.19.11A1.18,1.18,0,0,1,161.41,107.7Zm8.61-5c-.19,0-.81-.08-.81-1.11V87.14a1.86,1.86,0,0,1,.92-1.72l4.34-2.5a1.38,1.38,0,0,1,.7-.21,1,1,0,0,1,.68.25l.52.4a1.49,1.49,0,0,1,.54,1.29V96.32a3.41,3.41,0,0,1-.4,1.55l-.55,1a2.74,2.74,0,0,1-1,1.13l-4.35,2.5a1.1,1.1,0,0,1-.58.19Zm2.13-15.32a.91.91,0,0,0-.44.89V98.75l2.25-1.3a.9.9,0,0,0,.44-.89V86.12Zm14.53,7.71a.92.92,0,0,1-.89-.72L184.84,92a5.07,5.07,0,0,1-.25-1L184,86.35c0-.33,0-.52,0-.61s0-.32,0-.62l.58-5.26a8.49,8.49,0,0,1,.24-1.27l.95-3.56a2.21,2.21,0,0,1,1-1.4l.34-.2a1.23,1.23,0,0,1,.59-.19h.09l.17.05a.77.77,0,0,1,.46.8,2.13,2.13,0,0,1-.09.6l-1,3.38a6.16,6.16,0,0,0-.22,1.15l-.52,5q0,.39,0,.54a4.41,4.41,0,0,0,0,.51l.51,4.39a2.59,2.59,0,0,0,.2.82l1,2.26a1.48,1.48,0,0,1,.11.57,1.81,1.81,0,0,1-.21.81,1.73,1.73,0,0,1-.63.63l-.34.2a1.23,1.23,0,0,1-.58.17Zm-5.33-2.41c-.19,0-.8-.08-.8-1.07v-1a1.88,1.88,0,0,1,.92-1.76l.36-.21a1.18,1.18,0,0,1,.58-.18c.24,0,.81.12.81,1.15v1a1.79,1.79,0,0,1-.92,1.66l-.36.21a1.13,1.13,0,0,1-.59.19Zm0-8.34c-.19,0-.8-.07-.8-1.07v-1a1.9,1.9,0,0,1,.92-1.76l.36-.2a1.18,1.18,0,0,1,.58-.18c.24,0,.81.11.81,1.15v1A1.8,1.8,0,0,1,182.3,84l-.36.21a1.21,1.21,0,0,1-.59.18Z",
    style: {
      fill: "rgb(17, 113, 102)",
      opacity: 0.3,
      transformOrigin: "148.675px 105.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.28,136.84l-.19.1c-.46.27-.68.09-.68-.51V121.92a1.4,1.4,0,0,1,.68-1.33l.34-.19c.37-.22.63-.14.78.25l2.74,6.84a.56.56,0,0,0,.22.27.21.21,0,0,0,.24,0,.58.58,0,0,0,.25-.33,1.72,1.72,0,0,0,.1-.61v-8a1.41,1.41,0,0,1,.68-1.33l.18-.1c.46-.27.69-.09.69.53v14.52a1.38,1.38,0,0,1-.69,1.3l-.18.11c-.38.21-.64.14-.79-.23l-2.89-7.17c-.12-.3-.26-.4-.45-.3a.69.69,0,0,0-.25.36,1.74,1.74,0,0,0-.1.63v8.38A1.41,1.41,0,0,1,110.28,136.84Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "112.859px 127.165px"
    },
    id: "eldb87197k73",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,127.49l-.54,1a2.23,2.23,0,0,1-.84.94l-3.29,1.9a.71.71,0,0,1-.83,0l-.56-.43a1.08,1.08,0,0,1-.34-.92V118.34a2.93,2.93,0,0,1,.34-1.34l.54-1a2.26,2.26,0,0,1,.84-.93l3.3-1.91a.7.7,0,0,1,.84,0l.54.42a1.06,1.06,0,0,1,.34.91v11.72A2.89,2.89,0,0,1,124.41,127.49Zm-1.21-1.09V116c0-.61-.22-.78-.68-.52l-2.28,1.32a1.36,1.36,0,0,0-.68,1.3v10.4c0,.61.22.78.68.52l2.28-1.32A1.37,1.37,0,0,0,123.2,126.4Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "121.38px 122.242px"
    },
    id: "elc33rtstvxav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,111.34l5.39-3.11c.45-.26.68-.08.68.54V109a1.37,1.37,0,0,1-.68,1.28l-1.23.71a1.4,1.4,0,0,0-.68,1.32v12.42a1.42,1.42,0,0,1-.68,1.33l-.19.11c-.45.26-.68.08-.68-.54V113.23c0-.63-.23-.8-.68-.54l-1.25.72c-.45.26-.68.09-.68-.5v-.25A1.4,1.4,0,0,1,126.11,111.34Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "128.804px 117.2px"
    },
    id: "elfncm55zx5z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,105.33l5.36-3.1c.46-.26.68-.09.68.51V103a1.39,1.39,0,0,1-.68,1.31l-3.81,2.2a1.36,1.36,0,0,0-.68,1.3v3.86c0,.61.22.78.68.52L142,110c.46-.26.68-.09.68.52v.25A1.37,1.37,0,0,1,142,112l-3.81,2.2a1.38,1.38,0,0,0-.68,1.3v4.68a1.37,1.37,0,0,1-.69,1.3l-.18.11c-.46.27-.68.09-.68-.51V106.63A1.36,1.36,0,0,1,136.61,105.33Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "139.317px 111.912px"
    },
    id: "el9kvy8b37u1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,112.38l-.54,1a2.29,2.29,0,0,1-.84.94l-3.29,1.89a.71.71,0,0,1-.83,0l-.56-.42a1.08,1.08,0,0,1-.34-.92V103.22a2.89,2.89,0,0,1,.34-1.33l.54-1a2.23,2.23,0,0,1,.84-.94l3.3-1.91a.69.69,0,0,1,.84,0l.54.41a1.08,1.08,0,0,1,.34.92v11.72A2.89,2.89,0,0,1,150.59,112.38Zm-1.21-1.1v-10.4c0-.6-.23-.78-.68-.51l-2.28,1.31a1.39,1.39,0,0,0-.68,1.31v10.4c0,.6.22.77.68.51l2.28-1.32A1.38,1.38,0,0,0,149.38,111.28Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "147.56px 107.121px"
    },
    id: "elfr7vzpa8wlu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.51,92.63l.19-.1c.45-.27.68-.09.68.51v13.11a2.89,2.89,0,0,1-.34,1.33l-.55,1a2.16,2.16,0,0,1-.83,1l-3.29,1.9a.67.67,0,0,1-.83,0L153,111a1.09,1.09,0,0,1-.35-.92V96.94a1.4,1.4,0,0,1,.69-1.31l.18-.1c.46-.27.68-.09.68.51v12.45c0,.62.23.8.69.53l2.28-1.31a1.43,1.43,0,0,0,.68-1.33V93.94A1.41,1.41,0,0,1,158.51,92.63Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "156.012px 101.966px"
    },
    id: "el56l45h34oo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,107l-.19.11c-.45.26-.68.09-.68-.52V92.08a1.4,1.4,0,0,1,.68-1.32l.34-.2c.38-.22.64-.13.79.25l2.74,6.84a.51.51,0,0,0,.21.27.23.23,0,0,0,.25,0,.56.56,0,0,0,.25-.33,1.72,1.72,0,0,0,.09-.6V89a1.4,1.4,0,0,1,.68-1.32l.19-.11c.45-.26.68-.08.68.54v14.51a1.38,1.38,0,0,1-.68,1.3l-.19.11c-.37.22-.63.14-.78-.23l-2.9-7.16c-.11-.31-.26-.41-.44-.3a.67.67,0,0,0-.26.35,2,2,0,0,0-.1.64v8.38A1.37,1.37,0,0,1,162,107Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "164.58px 97.3412px"
    },
    id: "elwxvez0wajke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.09,97.66l-.55,1a2.27,2.27,0,0,1-.83.94l-4.34,2.5q-.69.39-.69-.51V87.14a1.37,1.37,0,0,1,.69-1.3l4.34-2.51a.69.69,0,0,1,.83,0l.55.42a1.06,1.06,0,0,1,.34.91V96.32A2.93,2.93,0,0,1,176.09,97.66Zm-4.17,1.52,2.28-1.32a1.38,1.38,0,0,0,.68-1.3V86.21c0-.61-.23-.78-.68-.52L171.92,87a1.37,1.37,0,0,0-.69,1.3V98.67Q171.23,99.57,171.92,99.18Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "173.057px 92.7046px"
    },
    id: "eltmy3epu47t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.07,83.58l-.36.2c-.46.27-.68.11-.68-.47v-1a1.41,1.41,0,0,1,.68-1.34l.36-.21c.45-.26.68-.08.68.56v1A1.35,1.35,0,0,1,182.07,83.58Zm0,8.33-.36.21c-.46.26-.68.1-.68-.47v-1a1.41,1.41,0,0,1,.68-1.35l.36-.21c.45-.26.68-.07.68.56v1A1.34,1.34,0,0,1,182.07,91.91Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "181.888px 86.4431px"
    },
    id: "elt7468m2ld8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,93.32a1.22,1.22,0,0,1-.15.58,1.15,1.15,0,0,1-.45.45l-.34.2q-.56.32-.78-.3l-1-2.47a3.66,3.66,0,0,1-.23-.94l-.57-4.55c0-.29,0-.47,0-.55s0-.3,0-.58l.57-5.24a7.33,7.33,0,0,1,.23-1.2l1-3.57A1.8,1.8,0,0,1,187,74l.34-.2a.62.62,0,0,1,.45-.11q.15.06.15.36a1.58,1.58,0,0,1-.07.47l-1,3.38a8,8,0,0,0-.24,1.22l-.51,5c0,.29,0,.48,0,.59s0,.29,0,.55l.51,4.4a4,4,0,0,0,.24,1l1,2.25A.94.94,0,0,1,188,93.32Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "186.24px 84.1713px"
    },
    id: "eln29lrqko0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg6mb0xffwy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142,102.23l-5.36,3.1a1.36,1.36,0,0,0-.68,1.3v14.49c0,.6.22.78.68.51l.18-.11a1.37,1.37,0,0,0,.69-1.3v-4.68a1.38,1.38,0,0,1,.68-1.3L142,112a1.37,1.37,0,0,0,.68-1.3v-.25c0-.61-.22-.78-.68-.52l-3.81,2.21c-.46.26-.68.09-.68-.52V107.8a1.36,1.36,0,0,1,.68-1.3l3.81-2.2a1.39,1.39,0,0,0,.68-1.31v-.25C142.65,102.14,142.43,102,142,102.23ZM115.62,117.4l-.18.1a1.42,1.42,0,0,0-.69,1.33v8a1.75,1.75,0,0,1-.09.61.58.58,0,0,1-.25.33.21.21,0,0,1-.24,0,.56.56,0,0,1-.22-.27l-2.74-6.84c-.15-.39-.41-.47-.78-.25l-.34.19a1.4,1.4,0,0,0-.68,1.33v14.51c0,.6.22.78.68.51l.19-.1a1.41,1.41,0,0,0,.68-1.31v-8.38a1.74,1.74,0,0,1,.1-.63.69.69,0,0,1,.25-.36c.19-.1.33,0,.45.3l2.89,7.17c.15.37.41.44.79.23l.18-.11a1.38,1.38,0,0,0,.69-1.3V117.93C116.31,117.31,116.08,117.13,115.62,117.4ZM150.05,98a.69.69,0,0,0-.84,0l-3.3,1.91a2.23,2.23,0,0,0-.84.94l-.54,1a2.89,2.89,0,0,0-.34,1.33v11.72a1.08,1.08,0,0,0,.34.92l.56.42a.71.71,0,0,0,.83,0l3.29-1.89a2.29,2.29,0,0,0,.84-.94l.54-1a2.89,2.89,0,0,0,.34-1.33V99.33a1.08,1.08,0,0,0-.34-.92Zm-.67,13.28a1.38,1.38,0,0,1-.68,1.3l-2.28,1.32c-.46.26-.68.09-.68-.51V103a1.39,1.39,0,0,1,.68-1.31l2.28-1.31c.45-.27.68-.09.68.51Zm-25.51,1.83a.7.7,0,0,0-.84,0l-3.3,1.91a2.26,2.26,0,0,0-.84.93l-.54,1a2.93,2.93,0,0,0-.34,1.34v11.71a1.08,1.08,0,0,0,.34.92l.56.43a.71.71,0,0,0,.83,0l3.29-1.9a2.23,2.23,0,0,0,.84-.94l.54-1a2.89,2.89,0,0,0,.34-1.33V114.44a1.06,1.06,0,0,0-.34-.91Zm-.67,13.29a1.37,1.37,0,0,1-.68,1.3L120.24,129c-.46.26-.68.09-.68-.52V118.1a1.36,1.36,0,0,1,.68-1.3l2.28-1.32c.46-.26.68-.09.68.52Zm8.3-18.17-5.39,3.11a1.4,1.4,0,0,0-.68,1.32v.25c0,.59.23.76.68.5l1.25-.72c.45-.26.68-.09.68.54v12.42c0,.62.23.8.68.54l.19-.11a1.42,1.42,0,0,0,.68-1.33V112.33a1.4,1.4,0,0,1,.68-1.32l1.23-.71a1.37,1.37,0,0,0,.68-1.28v-.25C132.18,108.15,132,108,131.5,108.23Zm27.2-15.7-.19.1a1.41,1.41,0,0,0-.68,1.31v12.44a1.43,1.43,0,0,1-.68,1.33L154.87,109c-.46.27-.69.09-.69-.53V96c0-.6-.22-.78-.68-.51l-.18.1a1.4,1.4,0,0,0-.69,1.31V110a1.09,1.09,0,0,0,.35.92l.56.42a.67.67,0,0,0,.83,0l3.29-1.9a2.16,2.16,0,0,0,.83-1l.55-1a2.89,2.89,0,0,0,.34-1.33V93C159.38,92.44,159.15,92.26,158.7,92.53Zm23.37-3.46-.36.21a1.41,1.41,0,0,0-.68,1.35v1c0,.57.22.73.68.47l.36-.21a1.34,1.34,0,0,0,.68-1.25v-1C182.75,89,182.52,88.81,182.07,89.07Zm4.85,1.61a4,4,0,0,1-.24-1l-.51-4.4c0-.26,0-.44,0-.55s0-.3,0-.59l.51-5a8,8,0,0,1,.24-1.22l1-3.38a1.58,1.58,0,0,0,.07-.47q0-.3-.15-.36a.62.62,0,0,0-.45.11L187,74a1.8,1.8,0,0,0-.78,1.11l-1,3.57a8.57,8.57,0,0,0-.23,1.2l-.57,5.24c0,.28,0,.48,0,.58s0,.26,0,.55l.57,4.55a4.14,4.14,0,0,0,.23.94l1,2.47q.22.61.78.3l.34-.2a1.15,1.15,0,0,0,.45-.45,1.22,1.22,0,0,0,.15-.58.94.94,0,0,0-.07-.39Zm-4.85-9.94-.36.21a1.41,1.41,0,0,0-.68,1.34v1c0,.58.22.74.68.47l.36-.2a1.35,1.35,0,0,0,.68-1.26v-1C182.75,80.66,182.52,80.48,182.07,80.74ZM167.3,87.56l-.19.11a1.4,1.4,0,0,0-.68,1.32v8a1.72,1.72,0,0,1-.09.6.6.6,0,0,1-.25.33.23.23,0,0,1-.25,0,.51.51,0,0,1-.21-.27l-2.74-6.84c-.15-.38-.41-.47-.79-.25l-.34.2a1.4,1.4,0,0,0-.68,1.32v14.51c0,.61.23.78.68.52L162,107a1.37,1.37,0,0,0,.68-1.3V97.32a2,2,0,0,1,.1-.64.67.67,0,0,1,.26-.35c.18-.11.33,0,.44.3l2.9,7.16c.15.37.41.45.78.23l.19-.11a1.38,1.38,0,0,0,.68-1.3V88.1C168,87.48,167.75,87.3,167.3,87.56Zm8.24-4.24a.69.69,0,0,0-.83,0l-4.34,2.51a1.37,1.37,0,0,0-.69,1.3v14.49q0,.9.69.51l4.34-2.5a2.27,2.27,0,0,0,.83-.94l.55-1a2.93,2.93,0,0,0,.34-1.34V84.65a1.06,1.06,0,0,0-.34-.91Zm-.66,13.24a1.38,1.38,0,0,1-.68,1.3l-2.28,1.32q-.69.39-.69-.51V88.31a1.37,1.37,0,0,1,.69-1.3l2.28-1.32c.45-.26.68-.09.68.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "148.697px 105.388px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5",
    className: "animable",
    style: {
      transformOrigin: "368.583px 338.429px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M336.76,378.62a47.74,47.74,0,0,0-12.54-3.75,23.23,23.23,0,0,0-8,.07,21.76,21.76,0,0,0-5.42,1.88c-5.88,2.92-6.73,6.17-6.92,8.92s1.33,6.43,6.19,9.83L393.48,454a206.08,206.08,0,0,0,42-29.64C399.24,407.52,340.1,380.05,336.76,378.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.672px 414.279px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5",
    className: "animable",
    style: {
      transformOrigin: "341.836px 317.201px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5",
    className: "animable",
    style: {
      transformOrigin: "372.716px 290.292px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M363.45,255.65c5.12,1,7.12,1.35,9.57,5.59s6.61,20,7.75,23.27,1.48,4.46,1,8.1c-.49,3.8-2.73,10.55-3.67,14.25-.44,1.71-.73,3.38-1.05,5.13a39.31,39.31,0,0,1-1.7,5.26,4.92,4.92,0,0,1-1.49,2.14c-.42.37-1,.41-1.4.75s-.51.94-1.07,1.22-1.34.12-1.89.44a18.17,18.17,0,0,1-1.69,1.1,3.44,3.44,0,0,0-1.43.83c-.36.39-.7,1.27-1.35,1.2s-.84-.77-.87-1.37a5.51,5.51,0,0,1,1.14-3.25,31.47,31.47,0,0,1,2.09-3,7.73,7.73,0,0,0,1.54-3.05c.23-.75.16-1.7-.81-1.27-1.13.52-2.33,1.6-3.69,1.36-.94-.16-1-.9-.45-1.52a28.16,28.16,0,0,0,2.48-3.25c.76-1.17,1.39-2.4,2.18-3.54a17.08,17.08,0,0,1,1.39-1.69c1.38-1.5,1.32-3.55,1.48-5.46.22-2.65.41-9.45.41-9.45l-6.2-15.27Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "372.716px 290.292px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M371.52,298.89c.06-3.15.19-6.3.31-9.45-2-4.86-4.14-10.21-6.1-15.27q3.24,7.59,6.3,15.25c-.16,3.16-.3,6.32-.51,9.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.88px 286.53px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-5",
    className: "animable",
    style: {
      transformOrigin: "344.578px 354.606px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.88,374.24c1.76-.62,3.07-.68,3.05.19a12.38,12.38,0,0,1-1.13,3.08l-1.4,1.93-.67,1.9s-.82,1-.87,1.1-.32-3.55-.32-3.55S326.55,374.69,328.88,374.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.631px 378.109px"
    },
    id: "elp8y1ws81x1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.78,300s-4,4.75-6.37,13.65a206.29,206.29,0,0,0-5,25.15c-.57,3.79-1.49,8.57-2.85,16-1.05,5.72-4.35,23.26-4.35,23.26s1.9,3.16,4.2,4.12c3.3,1.38,6.48.75,6.9-2.2,0,0,2.18-3.48,5.49-12.46a85.81,85.81,0,0,0,3.8-12.68,48.29,48.29,0,0,0,.29-8.17l13.28-23.09a37.51,37.51,0,0,1,5.24-7,13.31,13.31,0,0,0,2.87-4.44c2.2-6-1-14.07-1-14.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.631px 340.474px"
    },
    id: "el2hsfetas76a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.46,338.79c-2.14,13.15-4.59,26.25-7.2,39.31,2.3-13.12,4.76-26.21,7.2-39.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "332.86px 358.445px"
    },
    id: "el0o8ecpfs57n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,388.21l-.71-.14c.05-.27,5.37-27.65,9.09-39.15s13.47-34.34,13.57-34.57l.67.29c-.1.22-9.83,23.05-13.54,34.51S331.34,387.94,331.28,388.21Z",
    id: "eljm7ft09xezh",
    className: "animable",
    style: {
      transformOrigin: "342.235px 351.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.26,307.69H343.45a47.14,47.14,0,0,0-2,5.95,194.94,194.94,0,0,0-4.65,23.15c.53,3.57,1.13,7.24,1.68,9.76,1.47,6.66,2.39,11.36,3.55,14.11a44.06,44.06,0,0,0,3.95,6.64,84.48,84.48,0,0,0,3.71-12.42,48.29,48.29,0,0,0,.29-8.17l13-22.55h0l.93-3.55C367.14,315.24,366.77,311.21,365.26,307.69Z",
    id: "elbmd9ihtw0g6",
    className: "animable",
    style: {
      transformOrigin: "351.591px 337.495px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,383.11c-.39-.18-.87,1.35-.91,1.9s1,2.79,3.73,4.44,7.42,2.57,9.18,3.12,3.17,2,5.49,3.13c2.06,1,5.17,1.53,6.53.92a2.11,2.11,0,0,0,1-1.46c.37-1.13.34-1.39.2-1.43Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "323.203px 389.987px"
    },
    id: "elkohj3gnlaop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,391.23a9.89,9.89,0,0,1-1.13,3.29,3.74,3.74,0,0,1-2.81.71,12,12,0,0,1-5.91-2.06,18.67,18.67,0,0,0-4.3-2.07,46,46,0,0,1-6.13-1.94,16.1,16.1,0,0,1-4.11-2.52c-1-.94-1.93-2-1.83-3.32a4.17,4.17,0,0,1,3.7-3.07,12.25,12.25,0,0,1,4.83.73,20.88,20.88,0,0,0,4.63,1c1.08.09,2.35,1,3.19.05,1-1.1,1.39-3.7,2.06-5,.11-.21.26-.44.49-.49s.61.23.82.51a9.93,9.93,0,0,0,3.66,2.84c3.86,1.91,5.65.9,5.65.9l.36-.8s.77.43-.21,2.23a29.15,29.15,0,0,0-2.08,4.63A16.85,16.85,0,0,0,337.19,391.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "325.805px 385.903px"
    },
    id: "elu56yvkjxa6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,383.32c1.21-4.48,6.29-3.28,9.57-2.15a16.55,16.55,0,0,0,3.59.83,14.06,14.06,0,0,1-3.64-.65c-3.24-1-8.11-2.28-9.52,2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "317.58px 381.738px"
    },
    id: "el1qn910nxify",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.22,381.18c-1.65.15-2.1,2.82-2.1,2.82a14,14,0,0,0,4.75,1.54,4.71,4.71,0,0,0,5.35-3.41c.7-2.23.06-5.35-.07-6.36a1.37,1.37,0,0,1,1-1.62,2.07,2.07,0,0,0-1.85,2.4c.05,1.2,0,3.57-.51,4.36S323.73,382.05,320.22,381.18Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "323.635px 379.88px"
    },
    id: "elu54pz5rxdyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.56,300a17,17,0,0,1,4,10.1,15.12,15.12,0,0,1-3.19,10c-.83,12.16-3.23,35.57-3.23,35.57,3.21,3.3,4,5.44,5.9,11.36,1.13,3.6,5.37,15.17,6.42,18.39-5.62.69-8.68,6.28-8.68,6.28s-9.9-14.62-14.66-23.22c-3.53-6.36-5.16-8.68-6.21-12.44-1.3-4.69-1.65-7.11-2.81-15s-2.27-17.93-2.84-25.71-1-16-1-16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.36px 345.515px"
    },
    id: "elzk5j2f49vr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.82,391.67c-5.77-8.5-11.43-17.1-16.39-26.1a53.73,53.73,0,0,1-4.19-8.25,63.19,63.19,0,0,1-2.12-9,429.08,429.08,0,0,1-4.84-49.06l.84,12.3c.76,12.31,2.29,24.56,4.25,36.72.71,4,1.45,8.13,3.27,11.81a353,353,0,0,0,19.18,31.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "349.05px 345.475px"
    },
    id: "elbbphuqu369t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.83,359.46c-2.91-7.42-6.4-47.81-6.22-61.77h-.73c-.06,4.67.29,12.28.89,20.63-2.37-1.2-3.9-3.4-3.9-14.46h-.73c0,11.12,1.45,13.81,4.69,15.3,1.22,16.54,3.4,35.67,5.32,40.58,2.85,7.26,17.72,31.79,17.86,32l.63-.38C366.49,391.14,351.66,366.67,348.83,359.46Z",
    id: "el11xwe6s6wb7o",
    className: "animable",
    style: {
      transformOrigin: "352.39px 344.715px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-5",
    className: "animable",
    style: {
      transformOrigin: "368.973px 397.506px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362,390.43c-.89,1.26-1.9,2.15.63,3.83,2,1.29,2.07,2.33,2.68,3.71a12.21,12.21,0,0,1,.48,4.15s3.36-5.07,2.38-8.34S362,390.43,362,390.43Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.689px 396.275px"
    },
    id: "elhp7cup0zon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.77,387.53a11.83,11.83,0,0,0,3.29,2.44c.85.53,1.73,1,2,2,0,.11-.5.71-.49.82a5.71,5.71,0,0,1-.05,1.43c-.19,1.65-1.09,2.87-1.29,4.51a12.51,12.51,0,0,1-.35,1.94,11.47,11.47,0,0,0-.19,2.35c-.05.82-.11,1.64-.15,2.46a4.11,4.11,0,0,0,0,1.05c.07.35-5.51,3.16-7.76,4.24a3.89,3.89,0,0,1-.41.17,5.82,5.82,0,0,1-4.11-.4c-4.48-1.63-4.2-3.25-4.2-3.25a3.56,3.56,0,0,1,2.13-3.14,4.67,4.67,0,0,1,.86-.39l0,0a5.77,5.77,0,0,1,3.48-.17,5.85,5.85,0,0,0,.31-2.07,22.2,22.2,0,0,0,.05-3.16,8.12,8.12,0,0,0-1.35-3.31c-.95-1.31-2-3-2.63-3.92s-.8-3.14,2.93-5.81c3.58-2.55,6.2-2,6.71-.95A14.74,14.74,0,0,0,372.77,387.53Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "368.558px 397.317px"
    },
    id: "elfw9ziu4wx8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,407.3c0-3.09,3.94-4.64,6.51-3.73-2.63-.49-6.13.73-6.51,3.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "362.255px 405.306px"
    },
    id: "elgwvxinwxnvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elimo38vgh0u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.14,405.19a3.39,3.39,0,0,1,1.59-1.77,5.26,5.26,0,0,1,.78.15C365.06,404,363.45,404.64,363.14,405.19Z",
    style: {
      opacity: 0.1,
      transformOrigin: "364.325px 404.305px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.58,392.94c1,.42.17,2-1,4.45a9.41,9.41,0,0,0-1.2,6c.24,2.17-.27,3.23-1.21,4s-7.92,3.82-7.92,3.82a12.8,12.8,0,0,0,2.75-7.33c.38-4.78.84-7.85,3.22-9.94A5.73,5.73,0,0,1,378.58,392.94Z",
    id: "el09bmmjet87r",
    className: "animable",
    style: {
      transformOrigin: "373.138px 401.937px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,407.29c.11.94,2.78,2.84,5.93,2.8s3.42-.71,3.91-4.4.83-8.82,2.43-11,3.7-3.5,6.77-2.7c.35.17,1.3,1.12.95,2,0,0,0-.7-1.26-1.07-1.08-.31-2.37-.28-4.17,1.28-2.11,1.81-2.58,6.08-2.82,9.74s-1.38,7.17-4.41,7.5a9.07,9.07,0,0,1-7.3-2.26A3.38,3.38,0,0,1,359,407.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "368.973px 401.638px"
    },
    id: "eluxmlhtf2lm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-5",
    className: "animable",
    style: {
      transformOrigin: "340.803px 270.032px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.94,232.69a4.06,4.06,0,0,1-.4-4c.51-1.3,1.57-2.67,4.66-4.27,3.68-1.9,13.78-3.26,18.78,3.35.72,1-9.22,19.65-8.73,23.52-2.58-2.71-11.09-12.24-11.09-12.24-2-.86-3.24-1.59-3.67-3.49A4.72,4.72,0,0,1,340.94,232.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.104px 237.074px"
    },
    id: "eldjd1c4dyik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,239c-3-.79-4.91-3.42-3.22-6.34-1.28,3,.43,5.18,3.22,6.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.234px 235.83px"
    },
    id: "elqgp3sgrhj6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.94,232.69c-1.26-1.38-.95-3.6,0-5.08a10,10,0,0,1,4.26-3.21,22.37,22.37,0,0,0-2.22,1.46c-2.09,1.45-3.65,4.5-2,6.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.654px 228.545px"
    },
    id: "elato7iaowq5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.46,238s-2.73,4.45-2.42,4.82a14.12,14.12,0,0,0,2,1.33Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "341.238px 241.075px"
    },
    id: "el3l1l0cpu6ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.46,238c-.68,1.43-1.5,2.78-2.17,4.2-.09.23-.28.5-.15.66a2.42,2.42,0,0,0,.6.5c-.27-.15-.72-.27-.78-.63a15.37,15.37,0,0,1,2.5-4.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "341.21px 240.68px"
    },
    id: "elb55y0jwdw55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.84,229.86c-1.83.87-3.41,2.27-4,6.28-.15,1.05.67,2.48.3,3.87-1.59,6,.3,11,1.46,12.05.78.74,4.88,1.07,7,.47,2.69-.75,8.54-3.39,11.33-7.6,3.28-5,4-11.6.39-14.27C357.23,226.9,347.79,228.94,345.84,229.86Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "353.128px 240.658px"
    },
    id: "elpkd3hzlyhbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,236.14c0,1.36.8,2.69.34,4.08-.85,3.87-.91,8.47,1.42,11.84-2.56-3.26-2.56-8-1.58-11.88.46-1.32-.3-2.67-.18-4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.527px 244.1px"
    },
    id: "el7kxfwr341rm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.83,247.76l1.06,7.37h0c1.65.35,1.8,2.3,1,3.77l.39,2.08L351,263l-1.26-10.31Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "356.05px 255.38px"
    },
    id: "elhduceq2vmh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.84,252.21c1,.53,3.05.92,5.91.52l-.17-1.46a18.2,18.2,0,0,1-2.79.8A10,10,0,0,1,343.84,252.21Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "346.795px 252.082px"
    },
    id: "elsi9e7v73bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.14,232a3.75,3.75,0,0,0,2.69,3.93,5.62,5.62,0,0,0-.48,3.07,3.25,3.25,0,0,0,2.06,2.83c.79.27,1-.08,1.31-.71.4-.89.91-2.25,2.82-2,2.19.3,2.77,3.6,1.49,5.76a3.19,3.19,0,0,1-2.47,1.66,2,2,0,0,1-1.49-.7s.14,2.88,3.85,4.59a10.91,10.91,0,0,0,7.57,1,75.53,75.53,0,0,0,4.87-6c4-5.84,4.85-16.53-2-18.45-.33-.09-6.56-1-9.6-.3C344.39,228.68,343.16,231.55,343.14,232Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.783px 239.063px"
    },
    id: "elqg2qvxxki1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.05,226.23a4,4,0,0,0-1.59,2.49,2.89,2.89,0,0,0,1,2.71c2,1.57,5.12-.26,5.49-2.58C365.37,226.11,362.07,224.73,360.05,226.23Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "361.702px 228.815px"
    },
    id: "elo4kfkz78uo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.68,227.1c-2.05,1.26-3.33,4.23-2.24,6.37.3.58.72,1.1,1,1.71.79,1.95-.36,4.1-.61,6.19a9.12,9.12,0,0,0,.83,4.84c.68,1.11,2.18,1.39,2.78,2.55.41.8.13,1.78.29,2.67.35,1.91,2.61,2.83,4.56,2.87a5.65,5.65,0,0,0,4.5-1.64,21.2,21.2,0,0,1,1.46-2c1.16-1.09,3-1,4.28-2a4.11,4.11,0,0,0,1.38-3.37,10.85,10.85,0,0,0-1-3.64c-.83-2-.17-3.29.25-5.32a4.91,4.91,0,0,0-2.92-5.39c-1.41-.56-3.13-.47-4.27-1.48a24.38,24.38,0,0,1-1.52-2C368.31,225.11,364.09,225.63,361.68,227.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.481px 240.084px"
    },
    id: "elk43syqnejar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,261.16a8.91,8.91,0,0,0-5.35-5.31c-1-.3-3.49-.72-3.49-.72.57,1.3-.39,2.16-2.08,2.55-2.17.51-5.48.56-7.73-.93l-.92-.57a74.8,74.8,0,0,0-7.26,2.18c-.49.23-3.2,1.14-7.46,10.71-1.82,4.09-1.28,8.24,2.07,11.19.19,2.59-1.48,8.42-1.48,8.42a55.43,55.43,0,0,0-.58,14.74s2,5.3,17.86,5.24c12.27,0,18.44-6,18.44-6-.15-3-4.87-13.53-4.4-17.07C368.08,280.43,372.81,271.18,369.73,261.16Z",
    style: {
      fill: "rgb(17, 113, 102)",
      transformOrigin: "353.081px 281.895px"
    },
    id: "ell40fgxyxzoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M342.9,258.36c3.23,2.63,3.48,6.24,3,11.11s-5.37,20.09-6.37,23.4-2.43,4.46-4.95,7.14-8.41,6.94-11.34,9.38c-1.36,1.13-2.57,2.31-3.86,3.54a39.8,39.8,0,0,1-4.46,3.26,5,5,0,0,1-2.46.86c-.56,0-1.05-.26-1.58-.22s-1,.46-1.58.36-1.16-.69-1.79-.76a17,17,0,0,1-2-.09,3.32,3.32,0,0,0-1.65-.17c-.52.1-1.31.61-1.8.18s-.22-1.12.1-1.63a5.53,5.53,0,0,1,2.84-2,30.56,30.56,0,0,1,3.45-1.19,7.76,7.76,0,0,0,3-1.57c.62-.47,1.12-1.29.09-1.5-1.22-.25-2.83-.08-3.8-1.07-.66-.68-.27-1.31.54-1.49a27,27,0,0,0,3.91-1.18c1.3-.5,2.53-1.13,3.84-1.59a18.46,18.46,0,0,1,2.13-.55c2-.41,3.15-2.1,4.39-3.55,1.74-2,4.73-5.82,6.76-8.56l3.07-14.85C334.32,267.56,335,260.8,342.9,258.36Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "323.94px 287.783px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,269.47a100.64,100.64,0,0,1-3.21,13c-.1.35-.21.69-.31,1-1.23,4.17-2.42,7.93-2.86,9.39-.9,3-2.17,4.24-4.28,6.44l-.67.7c-2.63,2.79-8.41,6.94-11.34,9.39-1.35,1.13-2.57,2.3-3.85,3.53a40,40,0,0,1-4.47,3.27,5,5,0,0,1-2.46.85c-.56.05-1.05-.26-1.58-.22s-1,.46-1.58.36-1.16-.69-1.79-.75a17,17,0,0,1-2-.1,3.43,3.43,0,0,0-1.65-.17c-.16,0-.35.11-.55.18l-.25.08a1.37,1.37,0,0,1-.35.08.77.77,0,0,1-.64-.16c-.55-.48-.23-1.11.09-1.62a5.52,5.52,0,0,1,2.84-2,30.62,30.62,0,0,1,3.45-1.2,7.76,7.76,0,0,0,3-1.57c.62-.47,1.12-1.28.09-1.5-1.22-.25-2.83-.08-3.79-1.06-.67-.69-.28-1.32.53-1.5a26.67,26.67,0,0,0,3.91-1.18c1.3-.5,2.54-1.13,3.84-1.58a15.86,15.86,0,0,1,2.13-.55c2-.41,3.15-2.11,4.39-3.55,1.74-2,4.73-5.83,6.77-8.57l3.06-14.85c1.94-8.1,2.65-14.86,10.52-17.29a8.19,8.19,0,0,1,2,2.38C346.21,263.06,346.24,265.93,345.88,269.47Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "323.909px 287.758px"
    },
    id: "elylsr07xh3cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M302,316.35a1.09,1.09,0,0,1-.08-1.44c.75-1.45,2.38-2.07,3.82-2.56a13.47,13.47,0,0,1,3-1,9,9,0,0,0,2.73-1.39,7.88,7.88,0,0,1-2.68,1.58,22,22,0,0,0-5.7,2.28c-.66.53-1.81,1.64-1.05,2.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "306.578px 313.155px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M307.74,307.43c-1.24-1.42,1.16-1.6,2.06-1.9,2.38-.61,4.48-1.92,6.82-2.58a8.7,8.7,0,0,0,3.37-1.27c1.63-1.29,3.38-3.88,4.73-5.51l4.5-5.73c1-5,2.59-12.79,3.78-17.87,1.27-6,3.22-12.41,9.9-14.21-6.58,1.87-8.5,8.24-9.72,14.25-1.2,5.16-2.64,12.71-3.77,18l-4.54,5.72c-1.39,1.64-3.1,4.18-4.79,5.51a8.82,8.82,0,0,1-3.41,1.27c-2.34.65-4.47,1.93-6.85,2.5-.91.29-3.29.42-2.08,1.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "325.146px 282.91px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.51,323.41a2.1,2.1,0,0,0,.31,1.1c.21-.26.39-.58.57-.78a3.44,3.44,0,0,1,1.43-.83,18.17,18.17,0,0,0,1.69-1.1c.54-.32,1.26-.13,1.89-.44s.65-.86,1.07-1.22,1-.38,1.4-.75a4.92,4.92,0,0,0,1.49-2.14,39.31,39.31,0,0,0,1.7-5.26c.32-1.75.61-3.42,1.05-5.13.94-3.7,3.18-10.45,3.67-14.25.47-3.64.13-4.84-1-8.1s-5.3-19-7.75-23.27c-2.32-4-4.25-4.54-8.81-5.44l-.27-.07-.46-.1-.36-.08-.46-.09-.27-.05-.66-.13-.5-.09-.13,0-.21,0-.53-3.69.13,0c.81-1,1.7-1.95,2.63-3.07a2.16,2.16,0,0,1,.29.43c.42.8.13,1.77.29,2.66.35,1.92,2.61,2.83,4.56,2.88a5.69,5.69,0,0,0,4.5-1.65,23.12,23.12,0,0,1,1.46-2c1.16-1.09,3-1,4.29-2a4.12,4.12,0,0,0,1.37-3.38,10.62,10.62,0,0,0-1-3.64c-.83-2-.17-3.29.25-5.31a4.92,4.92,0,0,0-2.91-5.4c-1.42-.56-3.14-.46-4.28-1.48a24.27,24.27,0,0,1-1.51-2c-1.6-1.75-4.35-1.9-6.65-1.26a3.21,3.21,0,0,0-1.94-.57c-3.12-2.42-7.19-3-10.68-2.72a10.5,10.5,0,0,0-3.49,2.39c-3.14,3.11-5,7.68-4.18,12,.16.81.41,1.59.54,2.4.33,2.07-.13,4.18-.12,6.28s.67,4.42,2.49,5.45c1.38.77,3.07.62,4.64.82,2.58.33,2.28,1.92,2.38,4.11a2.42,2.42,0,0,1-.08,1,1,1,0,0,1-.18.32c-.67.83-2.57,1.16-3.41,1.44a29.25,29.25,0,0,0-4.86,1.64,5.12,5.12,0,0,0-1.82,1.55c-1.91,2.68-2.72,5.87-3.53,9-.75,2.9-1.54,5.8-2.37,8.68q-1.12,3.92-2.34,7.8a27,27,0,0,1-2.82,6.71c-1.55,2.37-3.77,4.21-5.77,6.23-4.53,4.58-8.32,10.44-14.38,12.64-2.33.84-4.83,1.07-7.22,1.71-.83.22-1.77.66-2,1.43a1.37,1.37,0,0,0,.35-.08l.25-.08c.2-.07.39-.14.55-.18a3.43,3.43,0,0,1,1.65.17,17,17,0,0,0,2,.1c.63.06,1.1.64,1.79.75s1-.32,1.58-.36,1,.27,1.58.22a5,5,0,0,0,2.46-.85,40,40,0,0,0,4.47-3.27c1.28-1.23,2.5-2.4,3.85-3.53,2.93-2.45,8.71-6.6,11.34-9.39l.67-.7h0c2.1-2.19,3.37-3.42,4.27-6.43.44-1.46,1.63-5.22,2.86-9.39l.31-1a3,3,0,0,1,.68,2c.37,4.86,1.53,9.78,2.32,14.62.56,3.45,1.13,6.9,1.39,10.38.2,2.52.23,5,.27,7.56l.24,18c0,1,0,2,.05,3.06a66.58,66.58,0,0,0,.58,8.47,43.45,43.45,0,0,0,1.61,7.3c.18.58.37,1.16.58,1.74,2.07,5.75,5.32,11,8.45,16.18A163.25,163.25,0,0,1,367.33,389a13.1,13.1,0,0,1,1.12,3.24c.32,1.94-.21,3.91-.36,5.87s.07,3.84,0,5.76a9.31,9.31,0,0,1-1.6,5.43,6,6,0,0,1-3.09,2.09,10.33,10.33,0,0,0,2.91.09,3.5,3.5,0,0,0,1.57-.54,75.44,75.44,0,0,0,7.24-3.52c.94-.75,1.45-1.82,1.22-4a9.33,9.33,0,0,1,1.19-6,14.22,14.22,0,0,0,1.46-3.51c.25-.85-.63-1.73-1-1.9-.25-1-1.13-1.48-2-2a11.77,11.77,0,0,1-3.28-2.44,14.4,14.4,0,0,1-1.25-3.18,1.36,1.36,0,0,0-.57-.57c-1.54-4.43-4.89-13.64-5.88-16.77-1.86-5.93-2.69-8.07-5.9-11.37,0,0,1.77-17.28,2.8-29.85l1.24-2.17c.13-.23.26-.45.4-.67a37.94,37.94,0,0,1,4.84-6.3c.18-.19.36-.41.54-.62-.27.45-.53.9-.83,1.34C366.91,319.23,365.42,321.18,365.51,323.41Zm6.12-20.62.12-.11a10,10,0,0,0-.37-1.92c-.23-.85-.55-1.86-.9-2.95-.11-.34-.23-.69-.35-1-.41-1.22-.85-2.52-1.25-3.78-.13-.39-.25-.78-.36-1.16s-.26-.84-.37-1.24-.16-.57-.23-.85c0-.09-.05-.19-.07-.28s-.09-.37-.13-.54c-.08-.33-.15-.64-.2-.94l-.06-.33a1.81,1.81,0,0,1,0-.23,3.56,3.56,0,0,1-.06-.44l0-.3a5.06,5.06,0,0,1,0-.54,4.17,4.17,0,0,1,0-.52,36.42,36.42,0,0,1,1.11-4.59c.32-1.16.68-2.4,1-3.72.95,1.77,1.87,3.54,2.79,5.32a28.42,28.42,0,0,1,2,4.4c1.1,3.46.83,7.21.41,10.82a53.84,53.84,0,0,1-2.72,12.08A21.05,21.05,0,0,0,371.63,302.79Z",
    style: {
      opacity: 0.3,
      transformOrigin: "342.318px 317.234px"
    },
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.b0d204eabe42dd35e95ac224d2daab07.svg";
export { ForwardRef as ReactComponent };